module.exports = __webpack_public_path__ + "static/media/Reward.4113bb79.mp3";